<script>
    import { fade } from 'svelte/transition';
    import SelectImage from "./SelectImage.svelte";
    import { business } from "../../firebase/auth";

    export let size = 100;

    let edit = false;
</script>


{#if edit === true}
    <SelectImage
        type = "stamp"
        name = "Stempel"
        imgSize = {{x: 360, y: 360}}
        businessId = {$business.id}
        on:cancel={() => {edit = false}}
        on:confirm={() => {edit = false}}
    />
{/if}
<button on:click={() => {edit = true}}>
    <div class="img-wrapper gradient" style="width: {size}px; height: {size}px">
        {#if $business.images?.stamp}
            <img src="{$business.images?.stamp??""}" alt="Avatar" width={size} height={size} style="width: {size}px; height: {size}px" in:fade="{{duration: 400}}" draggable="false">
        {/if}
    </div>
</button>

<style>
    button {
        padding: 0;
        border-radius: 50%;
        margin-bottom: 1rem;
    }

    .img-wrapper {
        display: block;
        padding: 0.5rem;
        font-size: 0;
        background-color: white;
        border-radius: 0.5rem;
        overflow: hidden;
        outline: 4px solid white;
        background-color: #EEE;
    }

    img {
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        transform: rotate(-5deg);
    }
</style>